import { render } from "./CompareIntegrationsPage.vue?vue&type=template&id=4d9aeb02"
import script from "./CompareIntegrationsPage.vue?vue&type=script&lang=js"
export * from "./CompareIntegrationsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__